import { FC } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import SearchBoxProductsOption from './components/SearchBoxProductsOption';
import useProductsSearchBar from './hooks/useProductsSearchBar';
import getOptionValue from './utils/getOptionValue';

type ProductsSearchBarProps = {
  productsSearchBarState: ReturnType<typeof useProductsSearchBar>;
  externalFields?: Record<string, unknown>;
};

const ProductsSearchBar: FC<ProductsSearchBarProps> = ({
  productsSearchBarState,
  externalFields,
}) => {
  const {
    loading,
    variants,
    searchValue,
    selectedValue,
    setSelectedValue,
    onSearchValueChange,
  } = productsSearchBarState;

  return (
    <Autocomplete
      disableCloseOnSelect
      fullWidth
      freeSolo={false}
      loading={loading}
      value={selectedValue}
      inputValue={searchValue}
      options={variants}
      onChange={(_, value) => {
        setSelectedValue(value);
      }}
      onInputChange={(_, value, reason) => {
        onSearchValueChange(value, reason as string);
      }}
      filterOptions={(option) => option}
      isOptionEqualToValue={(option, value) =>
        option.variant_id === value.variant_id
      }
      getOptionLabel={(option) => getOptionValue(option)}
      renderTags={() => null}
      renderOption={(props, option, { selected }) => {
        const { variant_id } = option;
        return (
          <li key={variant_id} {...props}>
            <SearchBoxProductsOption
              selected={selected}
              variant={option}
              externalFields={externalFields}
            />
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder='Search Products ...'
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {params.InputProps.startAdornment}
                <SearchIcon
                  sx={{
                    width: 15,
                    height: 15,
                    color: 'text.secondary',
                  }}
                />
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ProductsSearchBar;
